import { render } from "./CloudDataModal.vue?vue&type=template&id=36db5807&scoped=true"
import script from "./CloudDataModal.vue?vue&type=script&lang=js"
export * from "./CloudDataModal.vue?vue&type=script&lang=js"

import "./CloudDataModal.vue?vue&type=style&index=0&id=36db5807&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36db5807"]])

export default __exports__